module.exports = __webpack_public_path__ + "static/img/3-2.67ddb8f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/3-2.jpg
// module id = m/4V
// module chunks = 25